import { planKeys } from "../plan/keys";
import { createExerciseGoal, fetchExerciseGoals, fetchExerciseNotes, fetchExercisePreferences, fetchStrengthLevel, fetchStrengthLevels, putExerciseNote, putExercisePreference, removeExerciseGoal, removeExerciseNote, } from "./api";
import { exerciseKeys } from "./keys";
export function exerciseNotesOptions(api) {
    return {
        queryFn: ({ signal }) => fetchExerciseNotes(api, { signal }),
        queryKey: exerciseKeys.notes,
    };
}
export function putExerciseNoteMutation(api) {
    return {
        invalidates: [exerciseKeys.notes],
        mutationFn: ({ exerciseId, ...input }) => putExerciseNote(api, exerciseId, input),
        mutationKey: ["exercise", "notes", "put"],
    };
}
export function removeExerciseNoteMutation(api) {
    return {
        invalidates: [exerciseKeys.notes],
        mutationFn: ({ exerciseId }) => removeExerciseNote(api, exerciseId),
        mutationKey: ["exercise", "notes", "remove"],
    };
}
export function exercisePreferencesOptions(api) {
    return {
        queryFn: ({ signal }) => fetchExercisePreferences(api, { signal }),
        queryKey: exerciseKeys.preferences,
    };
}
/**
 * A preference moves the order of every candidate feed (`D200`), so the
 * feeds are invalidated with the list — the exclusion's own set, minus the
 * exclusion list itself.
 */
export function putExercisePreferenceMutation(api) {
    return {
        invalidates: [
            exerciseKeys.preferences,
            planKeys.candidatesAll,
            planKeys.sessionCandidatesAll,
            planKeys.alternativesAll,
        ],
        mutationFn: ({ exerciseId, ...input }) => putExercisePreference(api, exerciseId, input),
        mutationKey: ["exercise", "preferences", "put"],
    };
}
export function exerciseGoalsOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchExerciseGoals(api, options, { signal }),
        queryKey: exerciseKeys.goals(options),
    };
}
export function createExerciseGoalMutation(api) {
    return {
        invalidates: [exerciseKeys.goalsAll],
        mutationFn: (input) => createExerciseGoal(api, input),
        mutationKey: ["exercise", "goals", "create"],
    };
}
export function removeExerciseGoalMutation(api) {
    return {
        invalidates: [exerciseKeys.goalsAll],
        mutationFn: ({ goalId }) => removeExerciseGoal(api, goalId),
        mutationKey: ["exercise", "goals", "remove"],
    };
}
export function strengthLevelsOptions(api, options = {}) {
    return {
        queryFn: ({ signal }) => fetchStrengthLevels(api, options, { signal }),
        queryKey: exerciseKeys.strengthLevels(options.locale),
    };
}
export function strengthLevelOptions(api, exerciseId) {
    return {
        queryFn: ({ signal }) => fetchStrengthLevel(api, exerciseId, { signal }),
        queryKey: exerciseKeys.strengthLevel(exerciseId),
    };
}
//# sourceMappingURL=options.js.map